<template>
  <div class="formulaire">
    <h3>Obtenir mes coordonnées / Get my contact details</h3>
    <div v-if="errorMessage" class="message error">{{ errorMessage }}</div>
    <form @submit.prevent="submitEmail">
      <div class="form-group">
        <label for="codeAcces">Code d'accès / Access code
          <input type="text" id="codeAcces" v-model="codeAcces" disabled>
        </label>
      </div>
      <div class="form-group">
        <label for="email">Votre adresse e-mail / Your email address
          <input type="email" id="email" v-model="email" :disabled="loading" required>
        </label>
      </div>
      <div class="form-actions">
        <button type="submit" :disabled="loading">
          <span v-if="loading" class="spinner" />
          <span v-else>Valider / Commit</span>
        </button>
      </div>
    </form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import useMentionsLegalesStore from '@/stores/mentionsLegales';

interface ComponentData {
  codeAcces: string;
  email: string;
  errorMessage: string;
  loading: boolean;
  store: ReturnType<typeof useMentionsLegalesStore>;
}

export default defineComponent({
  name: 'MentionsLegalesForm1',

  data(): ComponentData {
    return {
      codeAcces: '',
      email: '',
      errorMessage: '',
      loading: false,
      store: useMentionsLegalesStore(),
    };
  },

  mounted() {
    this.fetchAccessCode();
  },

  beforeUnmount() {
    this.resetForm();
  },

  methods: {
    async fetchAccessCode() {
      this.loading = true;
      try {
        const response = await fetch('/api/mentions_legales_0');
        const data = await response.json();
        // Vérifier le statut de la réponse
        if (data.status === 'ok') {
          this.codeAcces = data.code_1;
          this.store.setToken(data.token);
        } else {
          // Gérer les erreurs retournées par le serveur
          const errorMsg = data.message || this.$t('errors.accessCodeFetch');
          this.errorMessage = errorMsg;
          // eslint-disable-next-line no-console
          console.error('API error:', { httpStatus: response.status, status: data.status, body: data });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Network error:', { error });
        this.errorMessage = this.$t('errors.accessCodeFetch');
      } finally {
        this.loading = false;
      }
    },

    async submitEmail() {
      this.errorMessage = '';
      this.loading = true;
      try {
        const response = await fetch('/api/mentions_legales_1', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email, token: this.store.token }),
        });
        const result = await response.json();
        if (result.status === 'ok') {
          this.$emit('change-etape', 'Form2');
        } else {
          this.errorMessage = result.message || this.$t('errors.generic');
          // eslint-disable-next-line no-console
          console.error('API error:', { httpStatus: response.status, status: result.status, body: result });
        }
      } catch (error) {
        this.errorMessage = this.$t('errors.generic');
        // eslint-disable-next-line no-console
        console.error('Network error:', { error });
      } finally {
        this.loading = false;
      }
    },

    resetForm() {
      this.codeAcces = '';
      this.email = '';
      this.errorMessage = '';
    },
  },
});
</script>
